<template>
  <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3 6.75C3 6.33579 3.33579 6 3.75 6H20.25C20.6642 6 21 6.33579 21 6.75C21 7.16421 20.6642 7.5 20.25 7.5H3.75C3.33579 7.5 3 7.16421 3 6.75ZM12 12C12 11.5858 12.3358 11.25 12.75 11.25H20.25C20.6642 11.25 21 11.5858 21 12C21 12.4142 20.6642 12.75 20.25 12.75H12.75C12.3358 12.75 12 12.4142 12 12ZM3 17.25C3 16.8358 3.33579 16.5 3.75 16.5H20.25C20.6642 16.5 21 16.8358 21 17.25C21 17.6642 20.6642 18 20.25 18H3.75C3.33579 18 3 17.6642 3 17.25Z"
    />
    <path
      d="M10.2307 15.7909C9.99846 16.0232 9.62187 16.0232 9.3896 15.7909L6.01928 12.4206C5.90774 12.309 5.84508 12.1577 5.84508 12C5.84508 11.8423 5.90774 11.691 6.01928 11.5794L9.38961 8.20911C9.62188 7.97685 9.99846 7.97684 10.2307 8.20911C10.463 8.44138 10.463 8.81797 10.2307 9.05024L7.28096 12L10.2307 14.9498C10.463 15.182 10.463 15.5586 10.2307 15.7909Z"
    />
  </svg>
</template>
